import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "fixed top-0 left-0 w-full h-0 flex justify-center items-start",
  style: {"z-index":"1010"}
}
const _hoisted_2 = {
  class: "relative top-24 mx-4 bg-white rounded shadow-xl",
  style: {"min-width":"240px","max-width":"520px"}
}
const _hoisted_3 = {
  key: 0,
  class: "w-full flex justify-between text-base font-medium"
}
const _hoisted_4 = { class: "flex-auto px-6 py-4 text-gray-800" }
const _hoisted_5 = { class: "w-full p-6 text-sm text-gray-600" }
const _hoisted_6 = { class: "w-full px-4 py-2.5 flex justify-end space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all ease-out transform duration-250",
      "enter-from-class": "opacity-0",
      "leave-active-class": "transition-all ease-out transform duration-250",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex justify-center items-start",
          style: {"z-index":"1000"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickMask && _ctx.handleClickMask(...args)))
        }, null, 512), [
          [_vShow, _ctx.mask && _ctx.isVisible]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-150 transform",
      "enter-from-class": "opacity-0 scale-50",
      "enter-to-class": "opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-100 transform",
      "leave-from-class": "opacity-100 scale-100",
      "leave-to-class": "opacity-0 scale-50"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.title || _ctx.closable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
                  (_ctx.closable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "flex-shrink-0 w-14 h-14 flex justify-center items-center f-clickable",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
                      }, [
                        _createVNode(_component_f_icon, {
                          name: "close",
                          size: "16"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_f_button, {
                type: _ctx.cancelType,
                onClick: _ctx.handleCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
                ]),
                _: 1
              }, 8, ["type", "onClick"]),
              _createVNode(_component_f_button, {
                type: _ctx.okType,
                onClick: _ctx.handleOk
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.okText), 1)
                ]),
                _: 1
              }, 8, ["type", "onClick"])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isVisible]
        ])
      ]),
      _: 3
    })
  ], 64))
}